import { render, staticRenderFns } from "./pbi-dashboard-sales-report.page.vue?vue&type=template&id=da6764fc"
import script from "./pbi-dashboard-sales-report.page.vue?vue&type=script&lang=ts"
export * from "./pbi-dashboard-sales-report.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports